export const ChartColorScheme = {
  domain: [
    '#3EC5D6',
    '#F6BB2D',
    '#F99226',
    '#6575BD',
    '#E3514D',
    '#5FC360',
    '#C8D548',
    '#2E81DA',
    '#FC65F1',
    '#24A8A8',
    '#E5A628',
    '#E27A24',
    '#4D5AAA',
    '#D34343',
    '#43AF43',
    '#B4BB1E',
    '#1C70BA',
    '#D65BDD',
  ],
};

export const SCurveScheme = {
  domain: ['#2E3940'],
};
